export default __webpack_public_path__ + "static/media/here-i-am-449.168309fd.mp3";